import { BaseResourceService } from '../client/base-resource-service.js';
import { API_ENDPOINTS } from '../config/api-config.js';

/**
 * Configurations Service (Public Routes Only)
 * Handles public configuration-related API endpoints
 */
export class ConfigurationsService extends BaseResourceService {
  constructor(httpClient) {
    super(httpClient, API_ENDPOINTS.CONFIGURATIONS);
  }

  /**
   * Get all configurations (PUBLIC)
   */
  async getAll(params = {}) {
    return this.client.get(this.path, params);
  }

  /**
   * Get configuration by ID (PUBLIC)
   */
  async getById(id) {
    return this.client.get(`${this.path}/${id}`);
  }

  /**
   * Get active work types for dropdown (PUBLIC)
   * This is explicitly marked as public access in the backend
   */
  async getActiveWorkTypes() {
    return this.client.get(API_ENDPOINTS.CONFIGURATIONS_ACTIVE_WORKTYPES);
  }

  /**
   * Filter configurations by type (PUBLIC)
   */
  async getByType(type) {
    return this.client.get(`${this.path}/type/${type}`);
  }

  /**
   * Get only active configurations (PUBLIC)
   */
  async getActiveConfigurations() {
    return this.client.get(`${this.path}/active/true`);
  }

  /**
   * Get all work type configurations (PUBLIC)
   */
  async getAllWorkTypes() {
    return this.client.get(`${this.path}/worktypes/all`);
  }

  /**
   * Get paginated results (PUBLIC)
   */
  async getPaginated(page = 1, limit = 10, filters = {}) {
    const params = {
      page,
      limit,
      ...filters
    };
    return this.client.get(this.path, params);
  }

  /**
   * Search configurations (PUBLIC)
   */
  async search(query, filters = {}) {
    const params = {
      search: query,
      ...filters
    };
    return this.client.get(this.path, params);
  }

  /**
   * Get customer's selected form controls (PUBLIC)
   */
  async getCustomerFields() {
    return this.client.get(`${this.path}/customer/fields`);
  }

  /**
   * Get dynamic form controls (PUBLIC)
   */
  async getFormControls() {
    return this.client.get(`${this.path}/formControls`);
  }

  // NOTE: The following methods are removed as they require authentication:
  // - create() - requires write permission
  // - update() - requires write permission
  // - patch() - requires write permission
  // - delete() - requires write permission
  // - initSubdomains() - requires authentication (requireAuth: true)
  // - getSubdomainConfig() - requires authentication (requireAuth: true)
  // - getValidSubdomains() - requires authentication (requireAuth: true)
  // - addSubdomain() - requires authentication (requireAuth: true)
  // - removeSubdomain() - requires authentication (requireAuth: true)
  // - updateSubdomainConfig() - requires authentication (requireAuth: true)
  // - initWorkType() - requires authentication (requireAuth: true)
  // - getWorkTypeConfig() - may require authentication
  // - syncWorkTypeFromManifest() - requires authentication (requireAuth: true)
  // - getGlobalWorkTypes() - requires authentication (requireAuth: true)
  // - getActiveGlobalWorkTypes() - requires authentication (requireAuth: true)
  // - getAllSubdomainConfigs() - requires authentication (requireAuth: true)
  // - createByType() - requires write permission
  // - updateByType() - requires write permission
  // - deleteByType() - requires write permission
  // - bulkUpdate() - requires write permission
  // - resetToDefaults() - requires write permission
}